import React from "react";

const Spinner = () => (
  <div style={overlayStyle}>
    <div style={containerStyle}>

      {/* Orbit rings */}
      <div style={outerRingStyle}>
        <div style={middleRingStyle}>
          <div style={centerGlowStyle} />
        </div>
      </div>

      <p style={titleStyle}>Loading Ela's universe</p>
      <p style={subtitleStyle}>Hold tight · something beautiful is forming</p>

      <div style={barFrameStyle}>
        <div style={barFillStyle} />
      </div>

      <p style={statusStyle}>
        Just a moment
        <span style={{ animation: "blink 0.9s step-end infinite" }}>...</span>
      </p>
    </div>

    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@1,400&family=DM+Sans:wght@400;500&display=swap');
      @keyframes load-progress {
        from { width: 0%; }
        to   { width: 100%; }
      }
      @keyframes blink {
        0%, 100% { opacity: 1;   }
        50%       { opacity: 0.1; }
      }
      @keyframes spin-outer {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
      @keyframes spin-middle {
        from { transform: rotate(0deg); }
        to   { transform: rotate(-360deg); }
      }
    `}</style>
  </div>
);

const overlayStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  width: "100vw",
  background:
    "radial-gradient(ellipse at 30% 50%, rgba(100,0,140,0.6) 0%, transparent 55%), " +
    "radial-gradient(ellipse at 70% 30%, rgba(140,0,100,0.3) 0%, transparent 50%), #0D0020",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 9999,
};

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "18px",
};

const outerRingStyle = {
  width: 88,
  height: 88,
  borderRadius: "50%",
  border: "1px solid rgba(255,179,217,0.25)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  animation: "spin-outer 5s linear infinite",
};

const middleRingStyle = {
  width: 56,
  height: 56,
  borderRadius: "50%",
  border: "1px solid rgba(212,184,255,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  animation: "spin-middle 3s linear infinite",
};

const centerGlowStyle = {
  width: 22,
  height: 22,
  borderRadius: "50%",
  background: "radial-gradient(circle, #fff8f0, #FFB3D9 60%)",
  boxShadow: "0 0 18px rgba(255,179,217,0.7), 0 0 36px rgba(199,125,255,0.3)",
};

const titleStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontStyle: "italic",
  fontWeight: 400,
  color: "#FFF0F7",
  fontSize: "1.3rem",
  letterSpacing: "0.04em",
  textShadow: "0 0 20px rgba(255,179,217,0.3)",
};

const subtitleStyle = {
  fontFamily: "'DM Sans', sans-serif",
  color: "rgba(255,235,250,0.4)",
  fontSize: "0.68rem",
  fontWeight: 400,
  letterSpacing: "0.1em",
};

const barFrameStyle = {
  position: "relative",
  width: "240px",
  height: "3px",
  background: "rgba(255,255,255,0.05)",
  borderRadius: "2px",
  overflow: "hidden",
};

const barFillStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  background: "linear-gradient(90deg, #FFB3D9, #D4B8FF, #A8EDEA)",
  borderRadius: "2px",
  boxShadow: "0 0 8px rgba(255,179,217,0.5)",
  animation: "load-progress 2.5s ease-in-out forwards",
};

const statusStyle = {
  fontFamily: "'DM Sans', sans-serif",
  color: "rgba(255,235,250,0.3)",
  fontSize: "0.65rem",
  fontWeight: 400,
  letterSpacing: "0.08em",
};

export default Spinner;
